import { Box, Card, CardContent, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from 'react';
import { useTranslation } from "react-i18next";

interface IFeatureCardProps {
	icon: JSX.Element;
	title: string;
	body: string;
}

function FeatureCard(props: IFeatureCardProps) {
	const theme = useTheme();
	const { t } = useTranslation();

	return (
		<Card className="feature-card">
			<CardContent className="feature-card-content">
				<Box className="feature-icon-container">
					{React.cloneElement(props.icon, { 
						className: "feature-icon"
					})}
				</Box>
				<Box textAlign="center" mb={2}>
					<Typography 
						variant="h6" 
						className="feature-title"
					>
						{props.title}
					</Typography>
				</Box>
				<Box textAlign="center">
					<Typography 
						variant="body2" 
						className="feature-description"
					>
						{props.body}
					</Typography>
				</Box>
			</CardContent>
		</Card>
	);
}

export default FeatureCard;
